import React from 'react';
/**
 * A reusable component to render text with line breaks from \n and \r\n characters.
 *
 * @param {string} text The text string containing newline characters.
 */
 export default function TextWithBreaks({ text }) {
    // If no text is provided, return null to render nothing.
    if (!text) {
      return null;
    }
  
    const lines = text.replace(/\r/g, '').split('\n');
    
    return (
      <>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {line}            
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </>
    );
  }